import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPairInputClass;
function PinnedPairInput() {
  if (PinnedPairInputClass === VOID) {
    class $ {
      constructor(players, pins) {
        this.s72_1 = players;
        this.t72_1 = pins;
      }
      toString() {
        return 'PinnedPairInput(players=' + toString(this.s72_1) + ', pins=' + toString(this.t72_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.s72_1);
        result = imul(result, 31) + hashCode(this.t72_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPairInput()))
          return false;
        if (!equals(this.s72_1, other.s72_1))
          return false;
        if (!equals(this.t72_1, other.t72_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPairInput');
    PinnedPairInputClass = $;
  }
  return PinnedPairInputClass;
}
//region block: exports
export {
  PinnedPairInput as PinnedPairInput36po72mbn91ld,
};
//endregion

//# sourceMappingURL=PinnedPairInput.mjs.map
